export const domainUrl = "https://jsan-backend.repla-projects.com/api"
// export const domainUrl = "https://jsan-backend.repla-projects.com/api"
// export const domainUrl = process.env.REACT_APP_DOMAIN_URL
// export const loginDomain = process.env.REACT_APP_IDENTITY_URL
// export const userloginDomain = process.env.REACT_APP_LOGIN_URL

// REACT_APP_IDENTITY_URL



